const URL = {
  // 测试环境
  test: 'http://logan-gateway.dev.logan.xiaopeng.local/xp-cs-api-boot/open/get/image',
  // 预发布环境
  pre: 'https://csapi.cs-pre.xiaopeng.com/open/get/image',
  // 生产环境
  production: 'https://ext-svc.xiaopeng.com/api/log/open/get/image'
}

const DEFAULT_OPTION = {
  // 默认是预发环境
  env: 'pre'
}

const IFRAME_URL = {
  // 测试环境
  test: 'http://static.test.xiaopeng.local/apps/xp-static-common/index.html',
  // 预发布环境
  pre: 'https://static.deploy-test.xiaopeng.com/apps/xp-static-common/index.html',
  // 生产环境
  production: 'https://static.xiaopeng.com/apps/xp-static-common/index.html'
}

export {
  URL,
  DEFAULT_OPTION,
  IFRAME_URL,
}
